module.exports = __webpack_public_path__ + "img/largeScreenTipLBootom.670ed0f6.png";